// Libs
import axios, { AxiosResponse } from 'axios';
// App
import { SHOP_ADMINISTRATION_SHOPS_URL } from '../shop.constants';
import { ShopSearchResult } from './shop-search-result.interface';
import useSearch, { SearchHookResponse } from 'app-shared/lib/api/utils/search-hook';
import { API_COMMON_BASE_URL } from 'app-shared/lib/api/utils/api.constants';

/**
 * Search shops by name api axios fetcher, including the shops that are not in the catalog
 * @param name a part of the shop name
 */
export const searchShopsByNameFetcher = (name: string): Promise<AxiosResponse<ShopSearchResult[]>> => {
  const url = `${API_COMMON_BASE_URL}/${SHOP_ADMINISTRATION_SHOPS_URL}/search`;

  return axios.get(url, { params: { name } });
};

export const useSearchShopsByName = (): SearchHookResponse<ShopSearchResult> => {
  const searchResponse = useSearch<ShopSearchResult>(searchShopsByNameFetcher);

  return searchResponse;
};
